/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { AccordionActions, Stack } from '@mui/material';
import { NavArrowDown } from 'assets/icons';
import * as S from './CampaignSectionAction.styled';

export const CampaignSectionAction = ({
  onClick,
  expanded,
  hidden,
  disabled,
  title,
  icon = <NavArrowDown />,
}) => {
  const onClickFunc = () => {
    if (disabled) return;
    onClick(expanded);
  };
  if (hidden) return null;
  return (
    <S.ActionContainer onClick={onClickFunc} disabled={disabled}>
      <AccordionActions>
        {expanded && (
          <Stack direction='row' spacing={1}>
            <S.SectionFooterText>{title}</S.SectionFooterText>
            <S.IconWrap>{icon}</S.IconWrap>
          </Stack>
        )}
      </AccordionActions>
    </S.ActionContainer>
  );
};
